import { Dente, Svg } from "./icones-do-laboratorio";

/** Ícones de traço das especialidades da clínica que a lucide não tem (24×24, cor do texto). */
type Props = { className?: string };

/** Perfil de rosto olhando pra direita: testa, nariz, boca e queixo. */
const PERFIL = "M9 2c3 0 5 1.5 5.8 4l1 2.5 1.7 2.3-1.5.7.6 1.6-.9.6.4 1.6c.2 1-.4 1.8-1.4 1.8h-2.2l-.3 3.9";

export function IconeDentistica({ className }: Props) {
  return (
    <Svg className={className}>
      <circle cx="12" cy="7" r="3.5" />
      <path d="M4.5 21c0-4 3.4-7 7.5-7s7.5 3 7.5 7M9.5 14.4 12 18l2.5-3.6" />
      <Dente x={16.2} y={18.4} escala={0.22} />
    </Svg>
  );
}

export function IconeEndodontia({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={12} y={11.5} escala={1} />
      <path d="M9.8 9.8c0-1.4 1-2 2.2-2s2.2.6 2.2 2c0 1-.5 1.6-.9 2.4l-.6 5.2M9.8 9.8c0 1 .5 1.6.9 2.4l.6 5.2" />
    </Svg>
  );
}

export function IconePeriodontia({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={10} y={13.2} escala={0.8} />
      <path d="M19 1.8l.8 1.7 1.7.8-1.7.8-.8 1.7-.8-1.7-1.7-.8 1.7-.8zM20.5 9l.4.9.9.4-.9.4-.4.9-.4-.9-.9-.4.9-.4z" />
    </Svg>
  );
}

export function IconeDtm({ className }: Props) {
  return (
    <Svg className={className}>
      <path d={PERFIL} />
      <path d="M9 2C5.7 2 3.2 4.6 3.2 8c0 2.2 1 3.8 2.3 5v8" />
      <circle cx="9" cy="12" r="1.3" />
      <path d="M10.9 10.1l.9-.9M11.3 12h1.3M10.9 13.9l.9.9" />
    </Svg>
  );
}

export function IconeEstomatologia({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={5.5} y={14} escala={0.5} />
      <Dente x={12.4} y={14} escala={0.5} />
      <circle cx="17.5" cy="7.5" r="3.5" />
      <path d="M20 10l2.5 2.5" />
    </Svg>
  );
}

export function IconeRadiologia({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={6} y={12.5} escala={0.55} />
      <rect x="10.5" y="3.5" width="11" height="15" rx="1.5" />
      <Dente x={16} y={11} escala={0.42} />
    </Svg>
  );
}

export function IconeOdontogeriatria({ className }: Props) {
  return (
    <Svg className={className}>
      <circle cx="8" cy="8" r="3" />
      <path d="M2 20c0-3.3 2.7-6 6-6 1.6 0 3 .6 4 1.6" />
      <circle cx="16.5" cy="9.5" r="2.7" />
      <path d="M11.5 20.5c0-3 2.2-5.3 5-5.3s5 2.3 5 5.3M14 8.2c.8-.9 4.2-.9 5 0" />
    </Svg>
  );
}

export function IconeNecessidadesEspeciais({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={8.5} y={12} escala={0.72} />
      <circle cx="19" cy="7" r="1.1" />
      <path d="M18.6 9.6V13h2.6l1.3 3.4M16.6 12.6a3.4 3.4 0 1 0 3.8 4.6" />
    </Svg>
  );
}

export function IconeProteseBucomaxilo({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={9} y={12} escala={0.72} />
      <circle cx="16.3" cy="19.5" r="1.8" />
      <circle cx="20.5" cy="17.5" r="1.8" />
      <path d="M17.2 17.9 21 6M19.1 16.5 14.5 7" />
    </Svg>
  );
}

export function IconeEsporte({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={8.5} y={12.5} escala={0.72} />
      <circle cx="19.5" cy="5" r="1.3" />
      <path d="M19 7.5l-1.6 4 2 2V18M16 9.5l2.6-2 2.6 1.5M17.4 11.5l-1.8 3.2" />
    </Svg>
  );
}

export function IconeTrabalho({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={12} y={15.3} escala={0.72} />
      <path d="M6.5 8a5.5 5 0 0 1 11 0M5 8h14M12 3v2.5" />
    </Svg>
  );
}

export function IconeSaudeColetiva({ className }: Props) {
  return (
    <Svg className={className}>
      <path d="M12 6.8 10.3 5.2a1.1 1.1 0 0 1 1.7-1.4 1.1 1.1 0 0 1 1.7 1.4z" />
      <circle cx="12" cy="11" r="2" />
      <path d="M8 20c0-2.5 1.8-4.5 4-4.5s4 2 4 4.5" />
      <circle cx="5" cy="13" r="1.7" />
      <circle cx="19" cy="13" r="1.7" />
      <path d="M1.5 20c0-2 1.5-3.5 3.5-3.5 1 0 1.8.3 2.4.9M22.5 20c0-2-1.5-3.5-3.5-3.5-1 0-1.8.3-2.4.9" />
    </Svg>
  );
}

export function IconeAcupuntura({ className }: Props) {
  return (
    <Svg className={className}>
      <Dente x={12} y={15} escala={0.72} />
      <path d="M12 9V3M9 9.5 5.5 4.5M15 9.5l3.5-5" />
      <circle cx="12" cy="2.4" r=".6" />
      <circle cx="5.1" cy="3.9" r=".6" />
      <circle cx="18.9" cy="3.9" r=".6" />
    </Svg>
  );
}

export function IconeHomeopatia({ className }: Props) {
  return (
    <Svg className={className}>
      <rect x="3.5" y="8" width="8" height="13" rx="1.5" />
      <path d="M5.5 8V5.5h4V8M5 5.5h5v-2H5zM3.5 12.5h8" />
      <path d="M13 20c0-6 3-10 9-11 0 6-3 10-9 11zM13 20l5-6" />
    </Svg>
  );
}

export function IconeCirurgiaEstetica({ className }: Props) {
  return (
    <Svg className={className}>
      <path d={PERFIL} transform="translate(-4 0)" />
      <path d="M4.5 4c-1.5 2-2 4.5-1.5 7s2 5 4.5 6.5" strokeDasharray="1.5 2" />
      <Dente x={19} y={17} escala={0.4} />
    </Svg>
  );
}
